import { RECIPE_EDITOR_KEY } from './RecipeEditor.consts';
import { initializeCustomFormDrawer } from '../../custom/CustomForm/CustomForm.initialize';
import { getRecipeFormProps } from './RecipeEditor.items';

export const initializeRecipeEditorDrawer = () => {
    initializeCustomFormDrawer(RECIPE_EDITOR_KEY, getRecipeFormProps);
};
